// extracted by mini-css-extract-plugin
export default {"DialogBuilder":"DialogBuilder_DialogBuilder__frQnY","Response":"DialogBuilder_Response__N+vqD"};